/**
 * Variables d'environnement **publiques** du back-office (DECISIONS §3.2).
 *
 * Seules des variables `VITE_*` sont lisibles ici : Vite les inscrit en clair dans le bundle.
 * Aucun secret ne porte donc jamais ce préfixe — le back-office ne connaît ni clé d'API ni mot
 * de passe : il envoie au serveur ce que l'administrateur saisit, et rien de plus.
 */
import { API_BASE_PATH } from '@elemora/shared/constants';

/**
 * Base des appels HTTP.
 *
 * Par défaut `/api/v1` (chemin relatif) : en développement, le proxy Vite relaie `/api` vers
 * `http://localhost:3000`, ce qui garde le cookie de refresh en first-party.
 */
function baseApi(): string {
  const configuree = import.meta.env.VITE_API_BASE_URL?.trim();
  const sansSlashFinal = configuree?.replace(/\/+$/, '');
  return sansSlashFinal !== undefined && sansSlashFinal.length > 0 ? sansSlashFinal : API_BASE_PATH;
}

export const env = Object.freeze({
  apiBaseUrl: baseApi(),
});
